import React, { createContext, useState, useContext } from "react";
import { createPortal } from "react-dom";

export const ModalContext = createContext(null);

export const withModal = (WrappedComponent) => {
  const Wrapper = (props) => {
    // create state managers
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const [modalTitle, setModalTitle] = useState(null);

    const startModal = (content, title = null) => {
      setModal(true);
      setModalContent(content);
      setModalTitle(title);
    };

    const endModal = () => {
      setModal(false);
      setModalContent(null);
      setModalTitle(null);
    };

    const ModalContextValue = {
      modal,
      modalContent,
      modalTitle,
      setModal,
      setModalContent,
      setModalTitle,
      startModal,
      endModal,
    };

    return (
      <ModalContext.Provider value={ModalContextValue}>
        <WrappedComponent {...props} />
        <Modal />
      </ModalContext.Provider>
    );
  };

  return Wrapper;
};

export const Modal = () => {
  const { modal, modalContent, modalTitle, endModal } = useContext(
    ModalContext
  );

  return createPortal(
    <div className={"modal " + (modal ? "is-active" : "")}>
      <div className="modal-background" onClick={() => endModal()}></div>
      <div className="modal-card">
        {modalTitle ? (
          <header className="modal-card-head">{modalTitle}</header>
        ) : null}
        <section className="modal-card-body">{modalContent}</section>
      </div>
      <button
        className="modal-close is-large"
        onClick={() => endModal()}
      ></button>
    </div>,
    document.getElementById("modal-root")
  );
};
